import React from 'react';
import { Image, ScrollView, useWindowDimensions, View } from 'react-native';

/** Alinha a borda esquerda dos cards ao conteúdo da tela (px-4). */
const H_PAD = 16;
const GAP = 12;

/**
 * Fotos do serviço em cards lado a lado: sem foto não renderiza (regra do
 * produto); com várias, os cards têm largura menor que a tela e o próximo
 * aparece "espiando" na borda, deixando claro que dá pra deslizar.
 */
export function ServiceCoverCarousel({ photos }: { photos: string[] }) {
  const { width } = useWindowDimensions();

  if (photos.length === 0) return null;

  const single = photos.length === 1;
  // Um card ocupa a largura útil; vários deixam o próximo espiar (~80%).
  const cardWidth = single ? width - H_PAD * 2 : Math.min(width * 0.8, 420);

  return (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{ paddingHorizontal: H_PAD, gap: GAP }}
      snapToInterval={single ? undefined : cardWidth + GAP}
      decelerationRate="fast"
    >
      {photos.map((uri, i) => (
        <View
          key={`${uri}-${i}`}
          className="overflow-hidden bg-neutral-100"
          style={{
            width: cardWidth,
            borderRadius: 16,
            borderCurve: 'continuous',
          }}
        >
          <Image
            source={{ uri }}
            accessibilityLabel={`Foto ${i + 1} de ${photos.length} do serviço`}
            style={{ width: '100%', aspectRatio: single ? 16 / 9 : 4 / 3 }}
            resizeMode="cover"
          />
        </View>
      ))}
    </ScrollView>
  );
}
